module.exports = __webpack_public_path__ + "img/icon-20.5f65aae3.svg";